import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { NavigationContent } from 'components/navigation/SectionsNav/SectionsNav.styled'
import { ReactComponent as IconLogoSmall } from './assets/logo-small.svg'
import { ReactComponent as IconOceanLogo } from './assets/logo.svg'

export const Overlay = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 49;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;

  ${({ theme }) => `
    background-color: ${theme.color.oceanDark};
  `}
`

export const Wrapper = styled.div`
  transition: all 0.5s ease;
  overflow-x: hidden;

  ${({ theme }) => `
    padding: calc(${theme.space.desktop.base} + 2px) ${theme.space.desktop.base};
  `}
`

export const LogoSection = styled.div`
  position: relative;

  a {
    display: inline-block;
  }

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.large};
  `}
`

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 263px;
  height: 81px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease;

  ${({ theme }) => `
    background-color: ${theme.color.white};
    border-radius: ${theme.borderRadius.base};
  `}
`

export const Logo = styled.img`
  position: relative;
  z-index: 2;
  max-width: 85%;
  max-height: 80%;
`

export const OceanLogo = styled(IconOceanLogo)`
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease;

  ${({ theme }) => `
    path {
      fill: ${theme.color.white}; 
    }
  `}
`

export const LogoSmall = styled(IconLogoSmall)`
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;

  ${({ theme }) => `
    path {
      fill: ${theme.color.white}; 
    }
  `}
`

export const UserSection = styled.div`
  opacity: 0;
  visibility: hidden;
  transform: translateX(25px);
  transition: all 0.4s ease;

  ${({ theme }) => `
    margin-bottom: calc(${theme.space.desktop.huge} - 3px);
  `}
`

export const SectionTitle = styled.div`
  position: relative;
  letter-spacing: 1px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  opacity: 0;
  visibility: hidden;
  transform: rotateX(90deg);
  transition: all 0.3s ease;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.base};
  `}
`

export const NavigationSection = styled.div`
  ${({ theme }) => `
    margin-left: -${theme.space.desktop.base};
    margin-right: -${theme.space.desktop.base};
  `}
`

export const EllipsisSection = styled.div`
  width: 20px;
  height: 20px;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.base};
    margin-bottom: calc(2px - ${theme.space.mobile.base});

    svg path {
      stroke: ${theme.color.white};
    }
  `}
`

export const NavTreeSection = styled.div``

export const PromoWrapper = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.space.mobile.huge};
  `}
`

export const VersionWrapper = styled.div`
  text-align: center;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.tiny};
  `}
`

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 84px;
  min-height: 100%;
  overflow-x: hidden;
  transition: all 0.5s ease;

  ${({ theme }) => `
    background-color: ${theme.color.oceanSidebar};
    ${theme.pattern};
  `}

  ${NavigationContent} {
    width: 0;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s cubic-bezier(0.7, 0, 0.84, 0);
  }

  ${NavTreeSection} {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s cubic-bezier(0.7, 0, 0.84, 0);
  }

  ${EllipsisSection} {
    opacity: 1;
    transition: opacity 0.5s ease-in;
  }

  ${PromoWrapper} {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s cubic-bezier(0.7, 0, 0.84, 0);
  }

  [data-selector='TrackVertical'] {
    width: 8.5px !important;
    right: 2px !important;
    background-color: transparent !important;
  }

  [data-selector='TrackVertical'] > div {
    background-color: rgba(100, 155, 210, 0.7) !important;
    border-radius: 4px !important;
  }

  /* Firefox native scrollbar */
  [data-test='Scrollbars'] > div:first-child {
    scrollbar-color: rgba(100, 155, 210, 0.7) transparent;
    scrollbar-width: auto;
  }

  ${media.sm`
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 50;
  `}

  ${media.lg`
    position: relative;
  `}

  &:hover {
    width: 360px;

    ${media.sm`
      & + ${Overlay} {
        opacity: 0.5;
        visibility: visible;
      }
    `}

    ${media.lg`
      & + ${Overlay} {
        opacity: 0;
        visibility: hidden;
      }
    `}

    ${Wrapper} {
      ${({ theme }) => `
        padding: calc(${theme.space.desktop.base} + 2px) calc(${theme.space.desktop.large} + 8px);
      `}
    }

    ${UserSection}, ${SectionTitle}, ${LogoWrapper}, ${OceanLogo}, ${NavigationContent}, ${NavTreeSection}, ${PromoWrapper} {
      opacity: 1;
      visibility: visible;
    }

    ${EllipsisSection} {
      opacity: 0;
      visibility: visible;
      transition: opacity 0.05s ease-in;
    }

    ${SectionTitle} {
      transform: rotateX(0deg);
    }

    ${UserSection} {
      transform: translateX(0);
    }

    ${NavigationSection} {
      ${({ theme }) => `
        margin-left: -${theme.space.desktop.base};
        margin-right: -${theme.space.desktop.base};
      `}
    }
  }
`
